export default __webpack_public_path__ + "static/media/j.17abda5c.wav";